import { render, staticRenderFns } from "./player-mascot-registration-form.vue?vue&type=template&id=fd9179f4&scoped=true&lang=pug"
import script from "./player-mascot-registration-form.vue?vue&type=script&setup=true&lang=js"
export * from "./player-mascot-registration-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./player-mascot-registration-form.vue?vue&type=style&index=0&id=fd9179f4&prod&lang=scss&scoped=true"
import style1 from "@ui-common/vue-file-upload/dist/vue-file-upload.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9179f4",
  null
  
)

export default component.exports